



























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import QuickInspectionCostComponent from "@/components/QuickInspectionCostComponent.vue";
import QuickInspectListComponent from "@/components/QuickInspectListComponent.vue";
import QuickSubHeader from "@/components/QuickSubHeader.vue";
import Number from "@/shared/filters/Number";

import { Utils } from "@/service/util";
import { INSPECT_TYPE } from "@/model/InspectType";
import { CouponData } from "@/model/Coupon";
import { ShakenShohiyou } from "@/model/ShakenShohiyou";
import { MESSAGE } from "@/model/Message";
import { QuickMitsumoriQrInfo } from "@/model/quickMitsumoriQrInfo";

import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import VueQrcode from "@chenfengyuan/vue-qrcode";

@Component({
  components: {
    InputNumber,
    QuickSubHeader,
    QuickInspectionCostComponent,
    QuickInspectListComponent,
    VueQrcode
  },
  filters: { Number }
})
export default class QuickMitsumoriContentPreview extends Vue {

  $refs!: {
    quickInspectionCostComponent: QuickInspectionCostComponent;
  };

  @Prop() seibiList: any;
  @Prop() shouhiyou: any;
  @Prop() couponData: any;
  @Prop() optionData: any;
  @Prop() preloadingQrInfo: any;
  @Prop() companyInfo: any;
  @Prop() isUseTechInfoAmount: boolean;
  header: any = {};

  inspectType: number = INSPECT_TYPE.RECOMMEND;

  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
  sumPrice!: (inspectType: number) => any;

  @Getter("currentState", { namespace: "QuickMitsumoriQrInfo" })
  currentStateQuickMitsumoriQrInfo: QuickMitsumoriQrInfo;

  /** 2021-10-11 sh #7458 change layout of quick mitsumori. [START] */
  @Getter("frontStaff", { namespace: "ReservationDetail" })
  frontStaff: number;
  /** 2021-10-11 sh #7458 change layout of quick mitsumori. [END] */

  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  @Getter("couponLabel", { namespace: "FunctionSetting" })
  couponLabel: string;
  @Getter("optionLabel", { namespace: "FunctionSetting" })
  optionLabel: string;
  /** 2024-05-02 nextage [END] */

  public utils: Utils = new Utils();

  // imgSrc: any = "https://work.extreme-service.jp/inspect_img/cus/1/79000115-63b4-41b8-a729-57820bf19a29.jpg";
  imgSrc: any = "https://work.extreme-service.jp/qr/img/100000/1000000000";

  option: any = {
    errorCorrectionLevel: "M",
    maskPattern: 0,
    margin: 0,
    scale: 2,
    width: 120,
    color: {
      dark: "#000000FF",
      light: "#FFFFFFFF"
    }
  };

  get mitsumoriDate() {
    let today = new Date();
    return today.getFullYear() + "/" +  (+today.getMonth() + 1) + "/"+ today.getDate();
  }

  get calcTotal1() {
    return (
      this.shouhiyou.kensaHiyou.subTotalZk +
      this.shouhiyou.houteiHiyou.zeiJibaisekiZk +
      this.shouhiyou.houteiHiyou.zeiWeightTax +
      this.shouhiyou.houteiHiyou.zeiInshidaiZk +
      this.shouhiyou.shakenHiyou.subTotalKazeiZk +
      this.shouhiyou.shakenHiyou.subTotalHikazeiZk +
      this.optionZk + this.couponZk +
      (this.shouhiyou.houteiHiyou.isUseTechInfoAmount == 1 ? this.shouhiyou.houteiHiyou.zeiTechInfoAmountZk : 0) 
    );
  }

  get calcTotal2() {
    return this.sumPrice(this.inspectType).totalZk;
  }

  /** 2021-10-11 sh #7458 change layout of quick mitsumori. [START] */
  get calcTotalGrand() {
    return this.calcTotal1 + this.calcTotal2;
  }
  /** 2021-10-11 sh #7458 change layout of quick mitsumori. [END] */

  get optionZk() {
    if (!this.optionData) {
      return 0;
    }
    return this.optionData.subTotalZk;
  }

  get couponZk() {
    if (!this.couponData) {
      return 0;
    }
    return this.couponData.subTotalZk;
  }

  get isHasQrInfo() {
    let isOK = false;
    if (this.currentStateQuickMitsumoriQrInfo) {
      if (this.currentStateQuickMitsumoriQrInfo.isHasImg == 1) {
        return true;
      }
    }
    return isOK;
  }

  sumItem(item: any) {
    return (item.buhinEditTotalZk || 0) + ( item.kouchinEditZk || 0);
  }

  get qrUrl() {
    let id = this.currentStateQuickMitsumoriQrInfo.id;
    let sknQuickMitsumoriId = this.currentStateQuickMitsumoriQrInfo.sknQuickMitsumoriId;
    // return `https://work.extreme-service.jp/skn/v1/qr/img/${sknQuickMitsumoriId}/${id}.png`;
    return this.currentStateQuickMitsumoriQrInfo.qrUrl;
  }

  get shopZip() {
    return `〒-${this.companyInfo.zip1}-${this.companyInfo.zip2}`;
  }

  get addr1() {
    return `${this.companyInfo.prefNm} ${this.companyInfo.addr1}`;
  }

  get addr2() {
    return `${this.companyInfo.addr2}`;
  }

  get shatenNm() {
    return `${this.companyInfo.shatenNm}`;
  }

  get kyotenNm() {
    return `${this.companyInfo.kyotenNm}`;
  }

  get tel() {
    return `TEL:${this.companyInfo.tel1}-${this.companyInfo.tel2}-${this.companyInfo.tel3}`;
  }

  get isHasQrInfoShop() {
    let isOK = false;
    if (this.companyInfo) {
      if (this.companyInfo.lineQr && this.companyInfo.lineQr != "") {
        return true;
      }
    }
    return isOK;
  }

  get qrInfoShopQr() {
    return this.companyInfo.lineQr;
  }

  /** 2021-07-28 sh #6989 sub item for quick mitsumori.(priority 2) [START] */
  isCourseSubItem(item: any) {
    if (item && item.rowNum === 0) {
      return "course-sub-item-nm";
    }

    return "";
  }
  /** 2021-07-28 sh #6989 sub item for quick mitsumori.(priority 2) [END] */

  /** 2021-10-11 sh #7458 change layout of quick mitsumori. [START] */
  get couponDataChecked() {
    let filterd = this.couponData.items.filter((e: any) => e.isCheck === 1);
    return filterd;
  }
 
  get optionDataChecked() {
    let filterd = this.optionData.items.filter((e: any) => e.isCheck === 1);
    return filterd;
  }

  get cssLoadingQrInfo() {
    if (this.preloadingQrInfo) {
      return "qm-detail__auto";
    }
    return "";
  }
  /** 2021-10-11 sh #7458 change layout of quick mitsumori. [END] */
}
